import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Grid, Row, Col, Glyphicon } from "react-bootstrap";
import { Checkbox, Form, Button, Icon } from 'semantic-ui-react'

import { translate, getLanguage } from "../Translation/Translation";

import "./InnerModal.css";
import "./InnerModalGDPR.css"

class InnerModalGDPR extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: true,
    }
    this.handleMouseMove = this.handleMouseMove.bind(this);
  }
  
  handleMouseMove(event) {
    event.stopPropagation();
  }

  handleChange = (event) => {
    this.props.reportCheckboxChanged(event.target.name);
  }

  render() {
    const {
      clickHandler,
      checkbox1,
      checkbox2, 
      checkbox3,
      checkbox4,
 
    } = this.props;
    return (
      <Grid className="innerModal-container">
        <Row>
          <Col md={12} className="innerModal"  onMouseDown={this.handleMouseMove}>
            <Row className="">
              <button
                onClick={clickHandler}
                className="innerModal-map-close-button"
              >
                &times;
              </button>

            
            </Row>
            <Row className="innerModal-content">
              <Col xs={12} sm={12}>
                  <h2>Ενημέρωση και Συγκατάθεση για την  Πολιτική  Προστασίας Προσωπικών Δεδομένων </h2>
                  <div className="event-info-container gdpr-container">
                  <p>
                  Η εταιρεία LIKNOSS και όλες οι συνδεδεμένες εταιρείες της (με έδρα Αγ. Παρασκευή Αττικής, οδός Μεσογείων 318, τηλ: 211-9558800) με την ιδιότητα της ως «Υπεύθυνου Επεξεργασίας», θέτει σε ισχύ από την 25-5-2018 «Πολιτική Προστασίας Δεδομένων», σε εφαρμογή του Κανονισμού ΕΕ 2016/679 που βρίσκεται στο site μας και στην οποία περιγράφεται αναλυτικά ο τρόπος άσκησης των δικαιωμάτων για τα προσωπικά δεδομένα υποψηφίων, υφισταμένων και πρώην πελατών, καθώς και των εν γένει συναλλασσόμενων με οποιαδήποτε ιδιότητα.
                  </p>
                  <p>
                  Με την παρούσα ζητάμε να μας επιβεβαιώσετε ότι ενημερωθήκατε:
                  </p>
                  <p>
                  1.	Για τα δικαιώματά της πληροφόρησης, πρόσβασης, διόρθωσης, διαγραφής, φορητότητας, περιορισμού επεξεργασίας, ανάκλησης, συγκατάθεσης/εναντίωσης προσωπικών δεδομένων, υποβολής καταγγελίας στην Αρχή Προστασίας Προσωπικών Δεδομένων (Κηφισίας 1-3, Τ.Κ. 115 23, Αθήνα, τηλ. 210 6475600, contact@dpa.gr)  
                  </p>
                  <p>
                  2.	Για τους σκοπούς επεξεργασίας:  την εξυπηρέτηση και υποστήριξη των συναλλαγών μαζί σας, και την επεξεργασίας που μας επιτρέπει να εκπληρώνουμε  τις συμβατικές μας και εκ του νόμου υποχρεώσεις μας προς τρίτους ή Αρχές.
                  </p>
                  <p>
                  3.	Για τη διαβίβαση των δεδομένων (Αποδέκτες) στη Διοίκηση και το Προσωπικό μας, τις θυγατρικές ή/και συνδεδεμένες εταιρείες μας, στους συνεργάτες /υπεργολάβους για την εκπλήρωση των υποχρεώσεων μας, στις αρμόδιες δημόσιες αρχές, στις συνεργαζόμενες εταιρείες ενημέρωσης οφειλετών για την ύπαρξη ληξιπρόθεσμων απαιτήσεων και σε δικηγόρους, όπως και σε ομοειδείς κατηγορίες αποδεικτών.
                  </p>
                  <p>
                  4.	Για τη διατήρηση των Δεδομένων μου για το σύνολο της διάρκειας της σύμβασης σε φυσικό και ηλεκτρονικό αρχείο και μετασυμβατικά για όσο ορίζει ο νόμος μέχρι την παραγραφή των τυχόν αστικών αξιώσεων.
                  </p>
                  <br />
                  <p>
                  <Form.Field name="checkbox1" onChange={this.handleChange} label={translate(getLanguage(), "Έχω διαβάσει τα παραπάνω και ενημερώθηκα ότι το πλήρες κείμενο της Πολιτικής Προστασίας Δεδομένων βρίσκεται αναρτημένο ηλεκτρονικά στο link www.liknoss.com/gdpr.")} control='input' type='checkbox' />
                  
                  </p>
                  <p>
                  5.	Υπηρεσίες Προσωποποιημένης Πληροφόρησης: 
                  </p>
                  <p>
                  Με την επιλογή σας συναινείτε στη εφαρμογή προσωποποιημένης πληροφόρησης και διατήρησης των δεδομένων σας για χρονικό διάστημα έως και 5 έτη μετά τη λήξη της σχέσης μας με σκοπό την προσωποποιημένη ενημέρωσή σας για τα νέα προϊόντα και υπηρεσίες της Εταιρείας LIKNOSS.  Αν δεν μας το επιτρέψετε, τα δεδομένα σας διατηρούνται μόνο για τους σκοπούς εξυπηρέτησής σας και λειτουργίας της σύμβασής σας και την ενημέρωσή σας για τις υπηρεσίες και προσφορές μέσα στη σύμβαση σας.

                  </p>
                  <p>
                  <Form.Field name="checkbox2" onChange={this.handleChange} label={translate(getLanguage(), "Συμφωνώ με τα παραπάνω, θα διαβάσω τους αναλυτικούς όρους της Υπηρεσίας Προσωποποιημένης Πληροφόρησης παραλαμβάνοντας το έντυπο ή στο site σας στο link  www.liknoss.com/gdpr")} control='input' type='checkbox' />
                  
                  </p>
                  <p>
                  <Form.Field name="checkbox3" onChange={this.handleChange} label={translate(getLanguage(), "Δεν συμφωνώ με τα παραπάνω, θα διαβάσω τους όρους της Υπηρεσίας Προσωποποιημένης Πληροφόρησης στο site σας και εφόσον αλλάξω γνώμη θα σας ενημερώσω. ")} control='input' type='checkbox' />
                  
                  </p>
                  <p>
                  <Form.Field name="checkbox4" onChange={this.handleChange} label={translate(getLanguage(), "Συμφωνώ με την παροχή εξατομικευμένης διαφήμισης προϊόντων και υπηρεσιών τρίτων εταιρειών ή μέσω τρίτων εταιρειών προϊόντων της LIKNOSS, με τις οποίες η LIKNOSS διατηρεί εμπορική συνεργασία. Σημειώνεται ότι η LIKNOSS δεν πρόκειται να διαβιβάσει/κοινοποιήσει στις τρίτες αυτές εταιρείες τα προσωπικά σας δεδομένα, που συνιστούν το προσωπικό σας προφίλ.")} control='input' type='checkbox' />                  
                  </p>
                </div>
              </Col>
            </Row>
            <Row className="innerModal-bottom">
              <Button style={{ marginRight: 20, borderRadius: 0}} disabled={!(checkbox1 && checkbox2 && checkbox4) || checkbox3} type="submit" onClick={this.props.submitForm}>
                {translate(getLanguage(), "Submit")}
              </Button>
            </Row>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default InnerModalGDPR;



// WEBPACK FOOTER //
// ./src/components/InnerModal/InnerModalGDPR.js